import { Alignment, Alignments } from '../schema/enum/alignments';

export function getTextAlignmentClass(alignment: Alignment | undefined): string {
    switch (alignment) {
        case Alignments.LEFT:
            return 'text-left';
        case Alignments.CENTER:
            return 'text-center';
        case Alignments.RIGHT:
            return 'text-right';
        default:
            return 'text-center';
    }
}